<!--TODO make this a button. add disabled attribute-->
<div
    style="
        border: 1px solid #cfcfcf;
        margin-left: 1.5%;
        margin-right: 1.5%;
        border-radius: 7px;
    "
>
    <div
        class="section-title text-left vertical-center"
        [class.no-focus]="!focus || focus.behaviourId == null"
        (click)="showScoring = !showScoring"
    >
        <span class="evaluation-check-icon">
            <cmps-icon svgIcon="evaluation-check-icon"></cmps-icon>
        </span>
        <span
            >&nbsp;{{
                _i18n._9646_EVALUATE_INTERACTION_FOCUS | translate
            }}</span
        >
        <button
            [disabled]="published"
            (click)="confirmReset($event)"
            class="reset-score-button"
        >
            {{ _i18n._9665_RESET | translate }}
        </button>
    </div>
    <ng-container *ngIf="focus && focus.behaviourId != null && showScoring">
        <ng-container *ngFor="let control of _form.controls; index as i">
            <div
                cmpsObservationScore
                [config]="config"
                [defaultNoteCategory]="defaultNoteCategory"
                [formControl]="control"
                [attr.data-trackingid]="_value[i].trackingId"
                [published]="published"
            ></div>
        </ng-container>
        <br />
    </ng-container>
</div>
